import { defineMessages } from 'react-intl';

export default defineMessages({
  subnavAria: {
    id: 'rewards.sr6RewardsPage.subnavAria',
    defaultMessage: 'rewards subnav',
    description: '',
  },
  subnavTabHowItWorks: {
    id: 'rewards.sr6RewardsPage.subnavTabHowItWorks',
    defaultMessage: 'How It Works',
    description: '',
  },
  subnavTabMyRewards: {
    id: 'rewards.sr6RewardsPage.subnavTabMyRewards',
    defaultMessage: 'My Rewards',
    description: '',
  },
});
